import styled from 'styled-components'
import { color, position, zIndex, right, left, bottom, top, space } from 'styled-system'

export default styled('span')`
    cursor: pointer;
    ${position}
    ${zIndex}
    ${color}
    ${right}
    ${left}
    ${bottom}
    ${top}
    ${space}
`
